import React, { Fragment } from 'react';
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";

const DropdownSchoolDesiTeachers = ({ control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, school_id } ) =>
{
    const mapFn = ( record )  =>
    {
        return {
            ...record, full_name: record.firstname + ' ' + record.surname
        }
    }

    // Suppress the fetch if a null school ID is provided
    const url = school_id === null ? null : '/schools/' + school_id + '/desiteachers' ;

    const fields = { url: url, keyFieldName: 'user_id', labelFieldName: 'full_name', mapFn };

    const [ loading, items ] = useListboxFetch( fields ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownSchoolDesiTeachers;
